(function () {
  const REVIEW_SEL = ".jm-review-item";
  const BODY_SEL = ".jm-review-content__body";
  const TOGGLE_CLASS = "cx-review-toggle";

  // Small buffer for rounding differences
  const OVERFLOW_EPS = 2;

  function expandBody(body) {
    body.style.maxHeight = "none";
    body.style.overflow = "visible";
    body.style.textOverflow = "clip";
    body.style.display = "block";
    body.style.webkitLineClamp = "unset";
    body.style.webkitBoxOrient = "unset";
  }

  function collapseBody(body) {
    const orig = body.dataset.cxCollapsedStyle || "";
    if (orig) body.setAttribute("style", orig);
    else body.removeAttribute("style");
  }

  function ensureCaptured(body) {
    if (body.dataset.cxCaptured === "1") return;
    body.dataset.cxCollapsedStyle = body.getAttribute("style") || "";
    body.dataset.cxCaptured = "1";
  }

  function removeToggle(review) {
    const existing = review.querySelector("." + TOGGLE_CLASS);
    if (existing) existing.remove();
  }

  function ensureToggle(review, body) {
    let toggle = review.querySelector("." + TOGGLE_CLASS);
    if (toggle) return toggle;

    toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = TOGGLE_CLASS;
    toggle.textContent = "More";

    body.insertAdjacentElement("afterend", toggle);

    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isExpanded = body.dataset.cxExpanded === "1";

      if (isExpanded) {
        collapseBody(body);
        body.dataset.cxExpanded = "0";
        toggle.textContent = "More";

        // keep the review in view when collapsing
        review.scrollIntoView({ block: "nearest", behavior: "smooth" });
      } else {
        expandBody(body);
        body.dataset.cxExpanded = "1";
        toggle.textContent = "View less";
      }
    });

    return toggle;
  }

  function isOverflowingWhenCollapsed(body) {
    // Must be collapsed before we measure overflow
    // scrollHeight = full content height
    // clientHeight = visible height
    return body.scrollHeight > body.clientHeight + OVERFLOW_EPS;
  }

  function processOne(review) {
    const body = review.querySelector(BODY_SEL);
    if (!body) return;

    // Capture the original collapsed inline style ONCE
    ensureCaptured(body);

    // Initialize state ONCE (start collapsed)
    if (!body.dataset.cxInit) {
      body.dataset.cxInit = "1";
      body.dataset.cxExpanded = "0";
      collapseBody(body);
    } else {
      // If it was expanded previously, keep it expanded (don’t force-close on rerender)
      if (body.dataset.cxExpanded === "1") {
        expandBody(body);
      } else {
        collapseBody(body);
      }
    }

    // If expanded, we definitely want the toggle visible
    if (body.dataset.cxExpanded === "1") {
      const t = ensureToggle(review, body);
      t.textContent = "View less";
      return;
    }

    // Collapsed: only show toggle if the collapsed body is actually truncated
    // Defer measurement to next frame to ensure layout is up-to-date (important after async renders)
    requestAnimationFrame(() => {
      // If DOM changed, bail safely
      if (!document.body.contains(body)) return;

      // Re-collapse to ensure measurement is in collapsed state
      collapseBody(body);

      if (isOverflowingWhenCollapsed(body)) {
        const t = ensureToggle(review, body);
        t.textContent = "More";
      } else {
        removeToggle(review);
      }
    });
  }

  function processAll() {
    document.querySelectorAll(REVIEW_SEL).forEach(processOne);
  }

  // Initial run
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", processAll);
  } else {
    processAll();
  }

  // Re-run on Judge.me pagination / sorting / async renders
  let raf = null;
  const mo = new MutationObserver(() => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(processAll);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
